export default __webpack_public_path__ + "static/media/massup_grid_s.1bd9308c.jpg";